<!-- eslint-disable -->
<template lang="pug">
  .play-box.factorization(:class=`[{'multiplayer-play-box': playersNumber > 1}, multiplayerClass]`)
    template(v-if="!isLoading || isGamePaused")
      game-header(
        v-if="!inPuzzle && !isBattle"
        :time="playersNumber > 1 ? '' : getTime"
        :slug="type"
        :game-type="parameters && parameters.courseType"
        :answers="answers"
        @soundStateChanged="headerKey = !headerKey"
        :key="headerKey",
        :is-homework="!!exerciseId",
      )
      .factorization__block(v-if="isGamePaused || (!counter && isStarted && (!isOlympiad || (isOlympiad && !gameEnd))) && !(gameEnd && parameters.dictation)")
        .game-info__block
          game-info(
              v-if="isGamePaused || !isTimeOver && !isRunning && !isSingleScreen || !isTimeOver && isRunning || isBattle"
              :score="{left: !isBattle ? answers.good : userScore, right: !isBattle ? answers.bad : opponentScore}",
              :time="getTime",
              :time-with-hours="getTimeWithHours"
              :multiplayer-mode="playersNumber > 1"
              :player-name="parameters && parameters.playerName"
              :players-number="playersNumber"
              :place="place"
              :color-for-student="colorForStudent"
              :display-game-info="true"
              :is-game-paused="isGamePaused",
              :is-olympiad="isOlympiad"
              @parametersUpdate="handleParametersUpdate",
              @openModalFrame="showModalFrame = true",
              :is-from-battle="isBattle",
              :parameters="parameters",
              :opponent="opponent",
              :opponent-numbers="opponentNumbers",
              :is-opponent-answering="isOpponentAnswering",
              :game-allows-tips="true"
          )
        template(v-if="isTimeOver && isSingleScreen && !isOlympiad && !isBattle")
          .factorization__reaction-container
            .factorization__reaction
              .factorization__reaction-side.factorization__reaction-side--correct
                div
                  | {{ $i18n.t('trainer.trainer_gamePlayBox_correct') }}
                .factorization__reaction-count
                  | {{ answers.good }}
              result-image.factorization__reaction-image(:status="'success'")
              .factorization__reaction-side.factorization__reaction-side--incorrect
                div
                  | {{ $i18n.t('trainer.trainer_gamePlayBox_wrong') }}
                .factorization__reaction-count
                  | {{ answers.bad }}
            result-buttons(
              v-if="isSingleScreen"
              :exercise-id="exerciseId"
              games-type="multiplication"
              :show-restart-button="true"
              @restartGame="restartGame"
            )
        template(v-else-if="isTimeOver && !isSingleScreen && !isOlympiad && !isBattle")
          .factorization__reaction-side.factorization__reaction-side--correct
            div
              | {{ $i18n.t('trainer.trainer_gamePlayBox_right') }}
            .factorization__reaction-count(v-for="index in generatedCorrectAnswers.length")
              | {{ getFactorizationAnswerString(generatedCorrectAnswers, index- 1) }}
          result-image.digits-area__reaction-image(
            :status="correct ? 'success' : 'failure'",
            :is-multiplayer="!isSingleScreen"
          )
          .factorization__reaction-side.factorization__reaction-side--incorrect
            div
              | {{ $i18n.t('trainer.trainer_gamePlayBox_answer') }}
            .factorization__reaction-count(v-for="index in playerAnswers.length")
              | {{ getFactorizationAnswerString(playerAnswers, index - 1) }}
        .factorization__container(v-else-if="(isRunning || isBattle) && !gameEnd")
          .factorization__container-body(v-if="!isGamePaused")
            template(v-for="index in generatedCorrectAnswers.length")
              .factorization__number-rules(:class="exampleActionClass")
                .factorization__example-actions
                  .factorization__example-action(:style="{'color': playersNumber !== 0 && colorForStudent}")
                      img.factorization__emoji(:src="emojiImages[index - 1][0]")
                      | &nbsp;*&nbsp;
                      img.factorization__emoji(:src="emojiImages[index - 1][1]")
                  .factorization__example-action(:style="{'color': playersNumber !== 0 && colorForStudent}")
                    | &nbsp;= {{ Math.abs(expressionAnswer) }}
              .factorization__answer-form(v-if="!parameters.dictation")
                span.factorization__answer-text
                  | {{ $i18n.t('trainer.trainer_gamePlayBox_enterTheAnswer') }}
                .factorization__answer-row
                  .factorization__answer-field
                    .factorization__answer-left-part(:style="{'color': playersNumber !== 0 && colorForStudent}")
                      img.factorization__emoji(:src="emojiImages[index - 1][0]")
                      | =
                    .factorization__answer-rigth-part
                      cs-input.factorization__answer-input(
                        :class=`{
                                                  'answer-input_columned': hugeFont,
                                                  'answer-input_with-result-icon': isBattle,
                                              }`,
                        class="factorization__input"
                        maxlength="14"
                        @input.prevent.native="playerAnswers[index - 1][0] = handleDigitInput($event)"
                        v-focus="true"
                        :disabled="!isRunning"
                        :correct="correct"
                        :wrong="!correct && !isRunning"
                      )
                  .factorization__answer-field
                    .factorization__answer-left-part(:style="{'color': playersNumber !== 0 && colorForStudent}")
                      img.factorization__emoji(:src="emojiImages[index - 1][1]")
                      | =
                    .factorization__answer-rigth-part
                      cs-input.factorization__answer-input(
                        :class=`{
                                                    'answer-input_columned': hugeFont,
                                                    'answer-input_with-result-icon': isBattle,
                                                }`,
                        class="factorization__input"
                        maxlength="14"
                        @input.prevent.native="playerAnswers[index - 1][1] = handleDigitInput($event)"
                        v-focus="true"
                        :disabled="!isRunning"
                        :correct="correct"
                        :wrong="!correct && !isRunning"
                      )
            .factorization__answer-footer(v-if="!parameters.dictation")
              cs-button(@click="checkAnswer(!isSingleScreen)" color="blue")
                | {{ $i18n.t('trainer.trainer_gamePlayBox_reply') }}
          .pause-screen(v-if="isGamePaused && !isSingleScreen")
            svg-icon(name="pause" :aria-hiddent="true" height="50px" width="50px")
        template(v-else)
          .factorization__reaction-container(v-if="!isBattle")
            template(v-if="!isGamePaused")
              .factorization__reaction-multiplayer.bad-answer-image(v-if="playersNumber > 1")
                template(v-if="!gameEnd")
                  .factorization__reaction-side.factorization__reaction-side--correct(v-if="parameters.showAnswer || isCheckMultiplayerAnswersPressed")
                    div
                      | {{ $i18n.t('trainer.trainer_gamePlayBox_right') }}
                    .factorization__reaction-count(v-for="index in generatedCorrectAnswers.length")
                      | {{ getFactorizationAnswerString(generatedCorrectAnswers, index- 1) }}
                  result-image.digits-area__reaction-image(
                    :status="correct ? 'success' : 'failure'",
                    :is-multiplayer="!isSingleScreen"
                  )
                  .factorization__reaction-side.factorization__reaction-side--incorrect(v-if="parameters.showAnswer || isCheckMultiplayerAnswersPressed")
                    div
                      | {{ $i18n.t('trainer.trainer_gamePlayBox_answer') }}
                    .factorization__reaction-count(v-for="index in playerAnswers.length")
                      | {{ getFactorizationAnswerString(playerAnswers, index - 1) }}
                .factorization-help-text__end-multiplayer-game(v-else)
                  | {{ $i18n.t('common.common_gameSettings_endGame') }}
              .factorization__reaction(v-else)
                  .factorization__reaction-side.factorization__reaction-side--correct(v-if="parameters.showAnswer")
                      div
                          | {{ $i18n.t('trainer.trainer_gamePlayBox_right') }}
                      .factorization__reaction-count(v-for="index in generatedCorrectAnswers.length")
                          | {{ getFactorizationAnswerString(generatedCorrectAnswers, index- 1) }}
                  result-image.factorization__reaction-image(:status="reactionImageStatus")
                  .factorization__reaction-side.factorization__reaction-side--incorrect(v-if="parameters.showAnswer")
                      div
                          | {{ $i18n.t('trainer.trainer_gamePlayBox_answer') }}
                      .factorization__reaction-count(v-for="index in playerAnswers.length")
                          | {{ getFactorizationAnswerString(playerAnswers, index - 1) }}
              .factorization__reaction-result_buttons
                template(v-if="!gameEnd")
                  cs-button.factorization__reaction-result_button.retry-button(
                    v-if="!correct && !isCheckMultiplayerAnswersPressed",
                    color="blue",
                    @click="refreshGame",
                    v-focus="true"
                  )  {{ $i18n.t('trainer.trainer_games_tryAgain') }}
                  cs-button.factorization__reaction-result_button.retry-button(
                    v-else,
                    color="blue",
                    @click="refreshGame",
                    v-focus="true"
                  )  {{ $i18n.t('trainer.trainer_gamePlayBox_playOn') }}
                result-buttons(
                  v-else-if="isSingleScreen"
                  :exercise-id="exerciseId"
                  games-type="multiplication"
                  :show-restart-button="true"
                  @restartGame="restartGame"
                )
                  slot
            div(v-else)
              .pause-screen(v-if="isGamePaused && !isSingleScreen")
                svg-icon(name="pause" :aria-hiddent="true" height="50px" width="50px")
      .factorization__prepare-image(v-if="isPrepareImageShowen")
        game-preparation-counter(v-if="counter < 4 && !isGamePaused && !gameEnd" :counter="counter" :playersNumber="playersNumber")
      .factorization__show-answer-button(v-if="ableToShowButton && gameEnd && parameters.dictation")
        img.factorization__answer-turtle(src="../../../../assets/images/turtle/ru/ru_AnswerTurtle.svg")
        cs-button(pattern="primary-outline" color="blue" @click="showAnswer")
          | {{ $i18n.t('trainer.trainer_gamePlayBox_showAnswers') }}
      example-viewer.factorization__viewer(
        v-if="ableToShowAnswer"
        :examples-array="examplesArray"
      )
    .factorization__trainer-loader(v-else-if="isSingleScreen")
      progress(
        :value="this.loadedSound / this.soundObjects.length * 100"
        max="100"
      )
        | {{ this.loadedSound / this.soundObjects.length * 100 }}%
      |  {{ $i18n.t('trainer.trainer_gamePlayBox_gameLoading') }}
    calculating-answers(v-if="calculatingAnswers" :is-last-game-in-battle="isLastGameInBattle")
</template>

<script>
    import trainerConfig from '../../../../config/trainer';
    import GameMixin from '../../../../utils/trainer/game';
    import timer from '../../../../utils/trainer/timer';
    import GameHeader from '../../GameHeader.vue';
    import answerDurationMixin from '../../../../utils/trainer/answerDurationMixin';
    import MultiplayerPlayBoxMixin from '../../../../utils/multiplayer/playBoxMixin';

    import ExampleViewer from './ExampleViewer.vue';
    import GamePreparationCounter from '../../GamePreparationCounter.vue';
    import EndGameMixin from '../utils/endGame';
    import { isEqual } from 'lodash';
    import Progress from '../../../motivation/map/Progress.vue';
    import GameInfo from './../GameInfo.vue';
    import ResultImage from '../ResultImage.vue';
    import ResultButtons from '../ResultButtons.vue';
    import ModalFrameForIndividualSettings from '../ModalFrameForIndividualSettings.vue';
    import CalculatingAnswers from '../../CalculatingAnswersModal.vue';
    import Battle from '../../../../utils/battle/battleMixin';
    import {
        counterHandler,
        getIsCheckAnswersButtonAvailableComputed,
        getIsCheckAnswersButtonAvailableWatcher,
    } from '@/utils/multiplayer/counterHandler';
    import CsButton from '@/elements/CsButton.vue';
    import SvgIcon from '@/elements/SvgIcon.vue';
    import CsInput from '@/elements/CsInput.vue';

    const SECONDS_IN_MINUTE = 60;
    const EMOJI_AMOUNT = 16;

    function DEFAULT_DATA() {
        return {
            numbers: [],
            correctAnswer: null,
            isRunning: true,
            correct: null,
            isLoading: false,
            parameters: null,
            gameEnd: false,
            countdownInstance: null,
            resultInstance: null,
            counter: null,
            isStarted: false,
            loadedSound: 0,
            dictationTimer: null,
            dictationTime: 0,
            examplesPlayed: 0,
            ableToShowAnswer: false,
            ableToShowButton: false,
            emojiImages: [],
            prevEmojiNumbers: [],
            headerKey: false,
            infinityModeCompleted: false,
            isFocused: false,
            isInitiallyPaused: true,
            expressionAnswer: null,
            generatedCorrectAnswers: [],
            playerAnswers: [],
            examplesArray: [],
            prevExpressionAnswersArray: [],
            isGameFinished: false,
            isPlayerAnswersEmpty: false,
            isCheckMultiplayerAnswersPressed: false,
        };
    }

    export default {
        beforeDestroy() {
            if (!this.inPuzzle) {
                this.$createjs.Sound.removeAllSounds();
                this.$createjs.Sound.removeAllEventListeners();
            }
            this.beforeTabClosed();
            window.removeEventListener('beforeunload', this.beforeTabClosed);
        },
        mixins: [GameMixin, timer, answerDurationMixin, EndGameMixin, MultiplayerPlayBoxMixin, Battle],
        data() {
            return DEFAULT_DATA();
        },
        props: {
            exerciseId: {
                type: [Number, String],
                default: 0,
            },
            type: {
                type: String,
                default: '',
            },
            gameType: {
                type: String,
                default: '',
            },
            showTurtle: {
                type: Boolean,
                default: false,
            },
            playAgain: {
                type: Boolean,
                default: false,
            },
            inPuzzle: {
                type: Boolean,
                default: false,
            },
            isLastGameInBattle: {
                type: Boolean,
                default: false,
            },
        },
        created() {
            window.addEventListener('beforeunload', this.beforeTabClosed);
        },
        mounted() {
            this.isLoading = true;
            if (this.playersNumber > 1) {
                let el = document.querySelector('.games-wrapper');
                if (el) {
                    if (window.innerWidth < 1360) {
                        el.style['height'] = 'calc(100vh - 150px)';
                    }
                }
            }
            this.fetchData().then(() => {
                if (this.inPuzzle) {
                    this.isLoading = false;
                    this.start();
                    return;
                }
                if (!this.isSingleScreen) {
                    this.isGamePaused = true;
                    this.isLoading = false;
                    return;
                }
                this.$createjs.Sound.removeAllSounds();
                this.$createjs.Sound.removeAllEventListeners();
                this.$createjs.Sound.addEventListener('fileload', this.soundLoad);
                this.$createjs.Sound.alternateExtensions = ['mp3'];
                this.$createjs.Sound.registerSounds(this.soundObjects);
                if (this.$refs.input) {
                    this.$refs.input.focus();
                }
            });
        },
        watch: {
            refreshGameEvent: {
                handler() {
                    clearInterval(this.dictationTimer);
                    this.dictationTime = 0;
                    this.answers.good = 0;
                    this.answers.bad = 0;
                    this.correct = null;
                    this.examplesArray = [];
                    this.stopTimer();
                    this.time = 0;
                    this.gameEnd = false;
                    this.isGamePaused = true;
                    this.startFactorizationGame();
                },
            },
            continueGameEvent(val) {
                if (val && this.isAvailableExamplesToSolveAndTimeLimit) {
                    this.refreshGame();
                }
            },
            isRunning: {
                handler(val) {
                    this.$emit('checkAnswersReady', { status: val, playerPosition: this.place });
                },
                immediate: true,
            },
            parameters: {
                handler() {
                    this.startFactorizationGame();
                },
                deep: true,
            },
            correct(val) {
                if (this.isSingleScreen) {
                    this.$emit('playAgainReady', val !== null);
                } else {
                    let playBox = document.querySelectorAll('.play-box')[this.place - 1].parentElement;
                    if (playBox) {
                        if (val !== null && val) {
                            playBox.classList.add('play-box__correct-answer');
                        } else if (val !== null && !val) {
                            playBox.classList.add('play-box__incorrect-answer');
                        } else if (val === null) {
                            playBox.classList.remove('play-box__correct-answer');
                            playBox.classList.remove('play-box__incorrect-answer');
                        }
                    }
                }
                !this.isOlympiad && this.correctHandler(val);
            },
            answers: {
                handler(val) {
                    if (this.parameters.timeLimit && this.parameters.dictation) return;
                    this.gameEnd =
                        !this.isOlympiad && !this.isBattle
                            ? val.good >= this.parameters.amountOfExamples && !this.parameters.infinityAmountOfExamples
                            : val.good + val.bad >= this.parameters.amountOfExamples;
                },
                deep: true,
            },
            gameEnd(val) {
                if (val) {
                    this.$emit('playAgainReady', !this.isSingleScreen);
                    if (!this.parameters.dictation) {
                        clearTimeout(this.timer);
                        this.timer = null;
                    }
                    if (this.inPuzzle) {
                        this.$emit('finish', this.answers, this.time);
                    }
                }
            },
            isTimeOver(val) {
                if (val) {
                    if (this.parameters.dictation) {
                        this.ableToShowButton = true;
                        this.isRunning = false;
                        clearTimeout(this.timer);
                        this.timer = null;
                    }
                    this.gameEnd = true;
                    this.sendStat(false);
                    this.$toasted.info(this.$i18n.t('trainer.trainer_gamePlayBox_gameCompleted'));
                    this.$emit('finish', this.answers, this.time);
                }
            },
            isCheckAnswersButtonAvailable: getIsCheckAnswersButtonAvailableWatcher.call(this, {
                emitCheckAnswersReadyEvent: false,
                triggerCounterHandler: true,
            }),
            isCounterStarted: counterHandler,
            counter(val) {
                val > 0 ? this.preparation() : this.continue();
            },
            checkMultiplayerAnswers(val) {
                if (val && this.isRunning) {
                    this.isCheckMultiplayerAnswersPressed = true;
                    this.checkAnswer(true);
                }
            },
            playAgain(val) {
                if (
                    val &&
                    ((this.parameters.amountOfExamples && this.answers.good < this.parameters.amountOfExamples) ||
                        (this.parameters.timeLimit && this.time < this.parameters.timeLimit * SECONDS_IN_MINUTE))
                ) {
                    this.refreshGame();
                }
            },
            multiplayerGamesState(value) {
                if (value && !this.gameEnd) {
                    this.isGamePaused = value === 'paused';
                }
            },
            isGamePaused(value) {
                if (!value) {
                    if (this.isInitiallyPaused) {
                        this.isInitiallyPaused = false;
                        this.counter = 3;
                    } else {
                        this.continue();
                    }

                    if (!(this.isRunning || this.gameEnd)) {
                        this.refreshGame();
                    }
                } else {
                    this.isStarted = false;
                    this.stopTimer();
                    this.timer = null;
                }
                if (this.correct !== null) {
                    let playBox = document.querySelectorAll('.play-box')[this.place - 1].parentElement;
                    playBox.classList.remove('play-box__correct-answer');
                    playBox.classList.remove('play-box__incorrect-answer');
                }
            },
            parametersChangerCounter() {
                if (!this.gameEnd) {
                    this.time = 0;
                    this.correct = null;
                }
                this.fetchData();
            },
        },
        methods: {
            getFactorizationAnswerString(array, index) {
                return `${array[index][0] ?? '0'}  * ${array[index][1] ?? '0'}`;
            },
            startFactorizationGame() {
                this.generateExpressionProduct();
                this.generateCorrectAnswers();
                this.generateDefaultPlayerAnswersArray();
                this.generateEmojiImages();
                this.examplesArray.push({
                    result: this.expressionAnswer,
                    emojiArray: this.emojiImages,
                    correctAnswers: this.generatedCorrectAnswers,
                });
            },
            restartGame() {
                this.isCheckMultiplayerAnswersPressed = false;
                Object.assign(this, DEFAULT_DATA());
                clearTimeout(this.counterTimeout);
                this.gameStat = null;
                this.answers.good = 0;
                this.answers.bad = 0;
                this.resetTimer();
                this.fetchData();
                this.start();
            },
            startDictationTimer() {
                this.dictationTimer = setInterval(() => {
                    this.dictationTime++;
                    if (this.dictationTime === this.parameters.timeForAnswer) {
                        this.refreshGame();
                    }
                }, 1000);
            },
            soundLoad() {
                this.loadedSound++;
                if (this.loadedSound === this.soundObjects.length) {
                    this.isLoading = false;
                    this.start();
                }
            },
            start() {
                if (this.resultInstance) {
                    this.resultInstance.stop();
                }
                this.counter = 3;
            },
            preparation() {
                if (this.isSingleScreen) {
                    this.countdownInstance = this.$createjs.Sound.play('beep');
                    this.countdownInstance.volume = 0.6;
                }
                setTimeout(() => {
                    this.counter--;
                }, 1000);
            },
            continue() {
                this.isStarted = true;
                if (this.parameters.dictation && !this.parameters.timeLimit) {
                    this.setTimer();
                }
                if (!this.timer && this.isRunning && !this.isGamePaused) {
                    this.setTimer();
                }
                if (this.parameters.dictation && !this.gameEnd) {
                    this.startDictationTimer();
                }
                if (this.answerDuration) {
                    this.trackTime();
                }
            },
            correctHandler(isCorrect) {
                if (isCorrect) {
                    !this.isOlympiad && this.isSingleScreen && this.playResultSound('success');
                    this.answers.good++;
                } else if (isCorrect !== null) {
                    !this.isOlympiad && this.isSingleScreen && this.playResultSound('failure');
                    this.answers.bad++;
                }
            },
            playResultSound(result) {
                if (!this.isSingleScreen) {
                    return;
                }
                this.resultInstance = this.$createjs.Sound.play(result);
                this.resultInstance.volume = 0.6;
            },
            checkIsPlayerAnswersEmpty() {
                this.playerAnswers.forEach(answer => {
                    if (answer.length !== 2) {
                        this.isPlayerAnswersEmpty = true;
                    }
                });
            },
            checkAnswer(isMultiplayer = false) {
                this.isPlayerAnswersEmpty = false;
                this.checkIsPlayerAnswersEmpty();
                if (this.isPlayerAnswersEmpty && !isMultiplayer) {
                    return;
                }

                if (this.playerAnswers || isMultiplayer) {
                    this.isOpponentAnswering = true;
                    this.$store.commit('setPreviousNumbers', { position: 'first', numbers: this.numbers });

                    this.playerAnswers.forEach(answer => {
                        answer.sort();
                    });
                    this.correct =
                        this.playerAnswers.sort().toString() === this.generatedCorrectAnswers.sort().toString();

                    this.isRunning = false;
                    if (!this.isBattle) {
                        this.isFocused = false;
                    } else {
                        setTimeout(() => {
                            this.isFocused = false;
                        }, 1500);
                    }
                    if (!this.parameters.timeLimit) {
                        clearTimeout(this.timer);
                    }
                    if (!this.isOlympiad) {
                        this.isRunning = false;
                    } else {
                        this.correctHandler(this.correct);
                    }
                    if (this.answerDuration) {
                        this.stopTracking();
                    }
                    this.$nextTick(() => {
                        if (
                            !this.$offline &&
                            (this.user.type === 'student' || this.user.type === 'olympiads-student')
                        ) {
                            this.sendStat(this.correct);
                            if (this.isOlympiad) {
                                this.refreshGame();
                            }
                        }
                    });
                }
            },
            refreshGame() {
                if (this.gameEnd) {
                    return;
                }
                if (this.isCheckMultiplayerAnswersPressed) {
                    this.startFactorizationGame();
                }
                if (this.parameters.dictation && this.dictationTime >= this.parameters.timeForAnswer) {
                    this.examplesPlayed++;
                    clearInterval(this.dictationTimer);
                    this.dictationTime = 0;
                    this.isStarted = false;
                    if (this.parameters.infinityAmountOfExamples) {
                        this.startFactorizationGame();
                        this.continue();
                        return;
                    }
                    if (
                        this.examplesPlayed >= this.parameters.amountOfExamples &&
                        !this.parameters.infinityAmountOfExamples
                    ) {
                        this.gameEnd = true;
                        this.ableToShowButton = true;
                        this.isRunning = false;
                    } else {
                        this.startFactorizationGame();
                        this.continue();
                    }
                    if (!this.ableToShowButton) {
                        clearTimeout(this.timer);
                        this.timer = null;
                    }
                    return;
                }
                if (this.isRunning) {
                    return;
                }
                if (this.resultInstance) {
                    this.resultInstance.stop();
                }
                if (this.isOlympiad || this.correct || this.isBattle) {
                    this.startFactorizationGame();
                }
                this.correct = null;
                if (!this.parameters.timeLimit || this.isBattle) {
                    this.setTimer();
                }
                this.isRunning = true;
                this.isOpponentAnswering = false;
                this.isCheckMultiplayerAnswersPressed = false;
            },
            showAnswer() {
                this.ableToShowAnswer = true;
                this.ableToShowButton = false;
                clearTimeout(this.timer);
                this.timer = null;
            },
            beforeTabClosed() {
                if (this.isStarted && this.user.type === 'student' && !this.isBattle) {
                    this.gameEnd = true;
                    this.infinityModeCompleted = true;
                    this.sendStat(true);
                }
            },
            beforeGameRestart() {
                Object.assign(this, DEFAULT_DATA());
            },
            generateRandomNumberInAllowedRange(minValue, maxValue) {
                return Math.floor(Math.random() * (maxValue - minValue) + minValue);
            },
            generateDefaultPlayerAnswersArray() {
                this.playerAnswers = [];
                this.generatedCorrectAnswers.forEach(() => {
                    this.playerAnswers.push([]);
                });
            },
            generateCorrectAnswers() {
                let correctAnswers = [];
                this.parameters.numbers.forEach(number => {
                    if (
                        this.expressionAnswer % number === 0 &&
                        this.expressionAnswer / number <= 10 &&
                        !correctAnswers.some(answer =>
                            this.isArraysEqual(answer, [number, this.expressionAnswer / number])
                        )
                    ) {
                        correctAnswers.push([number, this.expressionAnswer / number].sort());
                    }
                });
                this.generatedCorrectAnswers = correctAnswers;
            },
            generateExpressionProduct() {
                const multiplier = this.generateRandomNumberInAllowedRange(1, 10);
                this.expressionAnswer = this.parameters.numbers
                    ? this.parameters.numbers[
                          this.generateRandomNumberInAllowedRange(0, this.parameters.numbers.length - 1)
                      ] * multiplier
                    : null;

                if (this.prevExpressionAnswersArray.includes(this.expressionAnswer)) {
                    this.generateExpressionProduct();
                } else {
                    this.prevExpressionAnswersArray.push(this.expressionAnswer);
                }

                if (this.prevExpressionAnswersArray.length === 9) {
                    this.prevExpressionAnswersArray = [];
                }
            },
            generateEmojiImages() {
                this.emojiImages = [];
                this.prevEmojiNumbers = [];
                this.generatedCorrectAnswers.forEach((value, index) => {
                    this.emojiImages.push([]);
                    this.emojiImages[index].push(`/imgs/emoji/${this.generateRandomEmoji()}.svg`);
                    this.emojiImages[index].push(`/imgs/emoji/${this.generateRandomEmoji()}.svg`);
                });
            },
            generateRandomEmoji() {
                let emojiNumber = Math.floor(Math.random() * EMOJI_AMOUNT + 1);
                while (this.prevEmojiNumbers.some(item => item === emojiNumber)) {
                    emojiNumber = Math.floor(Math.random() * EMOJI_AMOUNT + 1);
                }
                this.prevEmojiNumbers.push(emojiNumber);
                return emojiNumber;
            },
            isArraysEqual(firstArray, secondArray) {
                return isEqual(firstArray, secondArray) || isEqual(firstArray, secondArray.slice().reverse());
            },
        },
        computed: {
            isPrepareImageShowen() {
                return (
                    (!(this.gameEnd && this.parameters.dictation) && !this.isStarted && !this.isGamePaused) ||
                    (this.isRunning && this.isStarted && !this.gameEnd && !this.isGamePaused && this.counter > 0)
                );
            },
            reactionImageStatus() {
                return this.correct ? 'success' : 'failure';
            },
            isOlympiad() {
                return this.gameType === 'olympiad';
            },
            isSingleScreen() {
                return !this.playersNumber || this.playersNumber === 1;
            },
            isCheckAnswersButtonAvailable: getIsCheckAnswersButtonAvailableComputed.call(this, 0),
            hugeFont() {
                return (
                    this.exampleActionClass &&
                    (this.exampleActionClass.includes('huge') || this.exampleActionClass.includes('big'))
                );
            },
            exampleActionClass() {
                return 'factorization__example-action_font-big';
                // if (!largeNumbers) {
                //   if (this.numbers.length <= 4) {
                //     return 'equation__example-action--font-x-huge';
                //   }
                //   if (this.numbers.length <= 8) {
                //     return 'equation__example-action--font-big';
                //   }
                //   return 'equation__example-action--font-medium';
                // }
                // if (this.numbers.length <= 3) {
                //   return 'equation__example-action--font-huge';
                // }
                // if (this.numbers.length <= 4) {
                //   return 'equation__example-action--font-big';
                // }
                // if (this.numbers.length <= 5) {
                //   return 'equation__example-action--font-medium';
                // }
                // Uncomment this to make long equations fonts bigger
                // if (this.numbers.length <= 6) {
                //   return 'equation__example-action--font-small';
                // }
                // if (this.numbers.length <= 8) {
                //   return 'equation__example-action--font-tiny';
                // }
                // return 'equation__example-action--font-x-tiny';
                // return 'equation__example-action--font-small';
            },
            isTimeOver() {
                return (
                    this.parameters &&
                    this.parameters.timeLimit &&
                    this.time >= this.parameters.timeLimit * SECONDS_IN_MINUTE
                );
            },
            soundObjects() {
                if (!this.isSingleScreen) {
                    return;
                }
                let sounds = [];
                sounds.push(...trainerConfig.result);
                sounds.push(...trainerConfig.countdownSound);
                return sounds;
            },
            isCounterStarted() {
                return this.counter > 0;
            },
            multiplayerClass() {
                if (this.playersNumber === 2) {
                    return 'play-box__two-players';
                }
                if (this.playersNumber === 3) {
                    return 'play-box__three-players';
                }
                if (this.playersNumber === 4) {
                    return 'play-box__four-players';
                }
                if (this.playersNumber === 5) {
                    return 'play-box__five-players';
                }
                if (this.playersNumber === 6) {
                    return 'play-box__six-players';
                }
                if (this.playersNumber === 7) {
                    return 'play-box__seven-players';
                }
                if (this.playersNumber === 8) {
                    return 'play-box__eight-players';
                }
                return '';
            },
        },
        components: {
            CsInput,
            SvgIcon,
            CsButton,
            ResultButtons,
            ResultImage,
            Progress,
            GameHeader,
            ExampleViewer,
            GamePreparationCounter,
            GameInfo,
            ModalFrameForIndividualSettings,
            CalculatingAnswers,
        },
    };
</script>

<style lang="scss" scoped>
    .pause-screen {
        margin-top: 20px;
        .svg-icon {
            color: $x-color-white;
            background-color: $hsl-color-blue-56_5;
            border-radius: 50%;
        }
    }
    .go-to-trainer-button {
        margin-top: 5px;
    }

    @import '@/assets/sass/games/playbox.scss';

    .factorization__answer-row {
        display: flex;
        flex-direction: row;
        justify-content: center;
        flex-wrap: wrap;
        margin-bottom: 30px;
    }

    .factorization__block {
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
        @include media($xlg) {
            flex-direction: row-reverse;
        }
    }

    .factorization__container {
        width: 100%;
        @include inset-space($space-base);
        @include media($lg) {
            display: flex;
            height: 100%;
        }
    }
    .factorization__container-body {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        justify-content: center;
    }
    .factorization__number-rules {
        display: flex;
        justify-content: center;
        font-weight: 500;
        @include stack-space($space-large);
    }

    .factorization__example-action_font-medium {
        font-size: 22px;
        @include media($sm) {
            font-size: 28px;
        }
        @include media($md) {
            font-size: 32px;
        }
        @include media($xl) {
            font-size: 52px;
        }
        @include media($xxl) {
            font-size: 86px;
        }
    }

    .factorization__example-action_font-big {
        font-size: 32px;
        @include media($sm) {
            font-size: 42px;
        }
        @include media($md) {
            font-size: 52px;
        }
        @include media($xl) {
            font-size: 76px;
        }
        @include media($xxl) {
            font-size: 126px;
        }
    }

    .factorization__example-actions {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }

    .factorization__example-action {
        text-align: center;
        white-space: nowrap;
        font-weight: 500;
        color: $hsl-color-blue-56;
        line-height: 1;
        padding-top: $space-x-small;
        padding-bottom: $space-x-small;
    }

    .factorization__emoji {
        width: 0.75em;
        height: 0.75em;
    }

    .factorization__answer-form {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .factorization__answer-text {
        font-size: 22px;
        font-weight: 500;
        @include media($sm) {
            font-size: 32px;
        }
    }

    .factorization__answer-field {
        display: flex;
        align-items: center;
        margin: 20px 15px;
        width: 250px;
        @include media($sm) {
            width: 340px;
        }
    }

    .factorization__answer-left-part {
        display: flex;
        align-items: center;
        font-size: 58px;
        font-weight: 500;
        color: $hsl-color-blue-56;
        margin-right: 50px;
        :only-child {
            margin-right: 10px;
        }
        @include media($sm) {
            font-size: 72px;
        }
        @media screen and (min-width: 360px) {
            margin-right: 10px;
        }
    }

    .factorization__answer-input {
        width: 140px !important;
        height: 50px;
        font-size: 22px !important;
        text-align: center;
        @include media($sm) {
            width: 230px !important;
            height: 60px !important;
        }
        @include media($md) {
            height: 80px !important;
            font-size: 32px !important;
        }
    }

    .factorization__answer-footer {
        display: flex;
        justify-content: center;
        margin-top: 15px;
        @media screen and (max-width: 767px) {
            margin-right: 25px;
        }
    }

    .factorization__reaction-container {
        display: flex;
        align-items: center;
        flex-direction: column;
        flex-grow: 1;
        flex-shrink: 1;
    }

    .factorization__reaction {
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        flex-grow: 1;
        flex-shrink: 1;
        flex-wrap: wrap;
        @include stack-space($space-base);
        flex-direction: row;
        @include media($md) {
            flex-wrap: nowrap;
        }
        @media screen and (max-width: 655px) {
            justify-content: space-between;
        }
    }

    .factorization__reaction-multiplayer {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        flex-grow: 1;
        flex-shrink: 1;
        flex-wrap: wrap;
        @include media($md) {
            flex-wrap: nowrap;
        }
        @media screen and (max-width: 655px) {
            justify-content: space-between;
        }
    }

    .factorization__reaction-side {
        align-items: center;
        align-self: normal;
        font-weight: 500;
        font-size: 20px;
        @include media($sm) {
            width: auto;
            font-size: 28px;
        }
        @include media($md) {
            display: flex;
            flex-direction: column;
            justify-content: center;
            height: 100%;
            flex-grow: 1;
            align-self: center;
            font-size: 20px;
        }
        @media screen and ($md) and (max-width: 800px) {
            font-size: 18px;
        }
        @include media($lg) {
            font-size: 32px;
        }
        @include media($xlg) {
            font-size: 42px;
        }
        color: $hsl-color-green-58;
        @include stack-space($space-base);
        @include media($sm) {
            @include stack-space(0);
        }
        @media screen and (max-width: 768px) {
            width: 50%;
        }

        &:first-child {
            @media screen and (max-width: 767px) {
                order: 1;
            }
        }

        &:last-child {
            @media screen and (max-width: 767px) {
                order: 2;
            }
        }
    }

    .factorization__reaction-side--correct {
        color: $hsl-color-green-58;
    }

    .factorization__reaction-side--incorrect {
        color: $hsl-color-red-62;
    }

    .factorization__reaction-image {
        @include stack-space($space-base);
        @media screen and (max-width: 767px) {
            order: 3;
            margin: 0 auto;
        }
    }

    .factorization__reaction-result_buttons {
        display: flex;
        justify-content: center;
        text-align: center;
    }

    .factorization__reaction-result_link {
        @media screen and (max-width: 640px) {
            display: block;
            width: 100%;
            margin-bottom: 30px;
        }
        @include media($lg) {
            @include inline-space($space-small);
        }

        &:first-child {
            margin-right: 25px;
        }
    }

    .factorization__reaction-result_button {
        @media screen and (max-width: 640px) {
            width: 100%;
        }
    }

    .factorization__show-answer-button {
        display: flex;
        flex-direction: column;
        align-items: center;
        @include inset-space($space-base);
    }

    .factorization__answer-turtle {
        max-width: 180px;
        @include stack-space($space-base);
        @include media($xlg) {
            max-width: 240px;
        }
    }

    .factorization__prepare-image {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        flex-shrink: 1;
        justify-content: center;
        align-items: center;
        @include inset-space($space-base);
    }

    .factorization__trainer-loader {
        @include make-col(8, 12, 0);
        @include make-offset(2, 12);
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        height: 100%;
    }

    .factorization__viewer {
        @include inset-space($space-base);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        flex-grow: 1;
        flex-shrink: 1;
    }

    .bad-answer-image {
        justify-content: center;
    }

    .retry-button {
        width: auto;
    }

    .multiplayer-play-box {
        .factorization__block {
            padding: 0;
            align-items: center;
            flex-direction: column;
        }
        .factorization__container {
            padding: 0;
            flex-direction: column-reverse;
            justify-content: flex-end;
            align-items: center;
        }
        .factorization__prepare-image {
            justify-content: flex-start;
            @include inset-space($space-x-small);
        }
        .factorization__answer-text {
            display: none;
        }
        .factorization__answer-field {
            margin-bottom: 5px;
        }
        .factorization__reaction-container {
            height: 100%;
            align-items: center;
        }
    }

    .play-box__two-players {
        .factorization__example-action_font-big {
            font-size: 56px;
            @include media($xxl) {
                font-size: 72px;
            }
        }
        .factorization__example-action_font-medium {
            font-size: 36px;
            @include media($xxl) {
                font-size: 48px;
            }
        }
        .factorization__reaction-image_multiplayer {
            margin-bottom: 30px;
        }
        .factorization__reaction {
            flex-grow: 0;
            margin-top: 5rem;
            @include media($xxl) {
                margin-top: 12rem;
            }
        }
        .factorization__reaction-container {
            .cs-button {
                @include media($xxl) {
                    font-size: 18px;
                }
            }
        }
        .factorization-help-text__end-multiplayer-game {
            margin-top: 30%;
        }
    }

    .play-box__three-players {
        .factorization__example-action_font-big {
            font-size: 36px;
            @include media($xl) {
                font-size: 42px;
            }
            @include media($xxl) {
                font-size: 48px;
            }
        }
        .factorization__example-action_font-medium {
            font-size: 26px;
            @include media($xl) {
                font-size: 32px;
            }
            @include media($xxl) {
                font-size: 36px;
            }
        }
        .factorization__answer-field {
            width: auto;
        }
        .factorization__answer-left-part {
            font-size: 42px;
        }
        .factorization__answer-input {
            width: 120px !important;
            height: 40px !important;
            font-size: 22px !important;
            @include media($xl) {
                width: 180px !important;
                height: 60px !important;
                font-size: 26px !important;
            }
            @include media($xxl) {
                width: 230px !important;
                height: 80px !important;
            }
        }
        .cs-button {
            padding: 10px 30px;
            @include media($xl) {
                padding: 15px 50px;
            }
            @include media($xxl) {
                padding: 15px 70px;
                font-size: 18px;
                margin-top: 10px;
            }
        }
        .factorization__reaction-container {
            .factorization__reaction-image_multiplayer {
                margin-bottom: 30px;
                max-width: 60%;
                @include media($xl) {
                    max-width: 80%;
                }
            }
            .cs-button {
                padding: 15px 50px;
            }
        }
        .factorization__reaction {
            flex-grow: 0;
            margin-top: 5rem;
            @include media($xxl) {
                margin-top: 12rem;
            }
        }
        .factorization-help-text__end-multiplayer-game {
            margin-top: 30%;
        }
    }

    .play-box__four-players {
        .factorization__container-body {
            @include media($xxl) {
                margin-bottom: 50%;
            }
        }
        .factorization__example-action_font-big {
            font-size: 32px;
            margin-bottom: 0;
            @include media($xl) {
                font-size: 36px;
            }
            @include media($xxl) {
                font-size: 42px;
                margin-bottom: 15px;
            }
        }
        .factorization__example-action_font-medium {
            font-size: 22px;
            margin-bottom: 0;
            @include media($xl) {
                font-size: 28px;
            }
            @include media($xxl) {
                font-size: 30px;
                margin-bottom: 15px;
            }
        }
        .factorization__answer-form {
            flex-direction: row;
            justify-content: center;
            @include media($xxl) {
                flex-direction: column;
            }
        }
        .factorization__answer-field {
            width: auto;
        }
        .factorization__answer-left-part {
            font-size: 42px;
            @include media($xxl) {
                font-size: 60px;
            }
        }
        .factorization__answer-input {
            width: 120px !important;
            height: 40px !important;
            font-size: 20px !important;
            @include media($xl) {
                width: 160px !important;
                height: 50px !important;
                font-size: 24px !important;
            }
            @include media($xxl) {
                width: 180px !important;
                height: 60px !important;
            }
        }
        .factorization__answer-footer {
            margin-top: 0;
            @include media($xxl) {
                margin-top: 20px;
            }
            .cs-button {
                padding: 10px 30px;
                margin-left: 15px;
                @include media($xxl) {
                    padding: 15px 50px;
                    font-size: 18px;
                }
            }
        }
        .factorization__reaction-container {
            .factorization__reaction-image_multiplayer {
                margin-bottom: 15px;
                max-width: 60%;
                @include media($xl) {
                    max-width: 80%;
                }
                @include media($xxl) {
                    max-width: 100%;
                }
            }
            .cs-button {
                padding: 10px 40px;
                @include media($xxl) {
                    padding: 15px 30px;
                    font-size: 18px;
                }
            }
        }
        .factorization__reaction {
            flex-grow: 0;
            margin-top: 1rem;
            @include media($xxl) {
                margin-top: 12rem;
            }
        }
        .factorization-help-text__end-multiplayer-game {
            margin-top: 10%;
        }
    }

    .play-box__five-players,
    .play-box__six-players {
        .factorization__example-action_font-big {
            font-size: 28px;
            margin-bottom: 0;
            @include media($xl) {
                font-size: 36px;
                margin-bottom: 10px;
            }
            @include media($xxl) {
                font-size: 40px;
                margin-bottom: 15px;
            }
        }
        .factorization__example-action_font-medium {
            font-size: 18px;
            margin-bottom: 0;
            @include media($xl) {
                font-size: 24px;
                margin-bottom: 10px;
            }
            @include media($xxl) {
                font-size: 28px;
                margin-bottom: 15px;
            }
        }
        .factorization__answer-form {
            flex-direction: row;
            justify-content: center;
        }
        .factorization__answer-field {
            width: auto;
        }
        .factorization__answer-left-part {
            font-size: 32px;
            @include media($xl) {
                font-size: 36px;
            }
            @include media($xxl) {
                font-size: 52px;
            }
        }
        .factorization__answer-input {
            width: 90px !important;
            height: 40px !important;
            font-size: 22px !important;
            @include media($xl) {
                width: 140px !important;
                height: 45px !important;
            }
            @include media($xxl) {
                width: 160px !important;
                height: 50px !important;
            }
        }
        .factorization__answer-footer {
            margin-top: 0;
            .cs-button {
                padding: 10px 30px;
                margin-left: 15px;
                @include media($xxl) {
                    padding: 15px 50px;
                }
            }
        }
        .factorization__reaction-container {
            .factorization__reaction-image_multiplayer {
                margin-bottom: 15px;
                max-width: 60%;
                @include media($xl) {
                    max-width: 80%;
                }
                @include media($xxl) {
                    max-width: 90%;
                }
            }
            .cs-button {
                padding: 10px 40px;
                @include media($xxl) {
                    padding: 15px 30px;
                    font-size: 18px;
                }
            }
        }
        .factorization__reaction {
            flex-grow: 0;
            margin-top: 1rem;
            @include media($xxl) {
                margin-top: 4rem;
            }
        }
        .factorization-help-text__end-multiplayer-game {
            margin-top: 20%;
        }
    }

    .play-box__seven-players,
    .play-box__eight-players {
        .factorization__example-action_font-big {
            font-size: 20px;
            margin-bottom: 0;
            @include media($xl) {
                font-size: 24px;
                margin-bottom: 10px;
            }
            @include media($xxl) {
                font-size: 38px;
                margin-bottom: 15px;
            }
        }
        .factorization__example-action_font-medium {
            font-size: 14px;
            margin-bottom: 0;
            @include media($xl) {
                font-size: 18px;
                margin-bottom: 10px;
            }
            @include media($xxl) {
                font-size: 24px;
                margin-bottom: 15px;
            }
        }
        .factorization__answer-form {
            flex-direction: row;
            justify-content: center;
        }
        .factorization__answer-field {
            width: auto;
        }
        .factorization__answer-left-part {
            font-size: 24px;
            @include media($xl) {
                font-size: 28px;
            }
            @include media($xxl) {
                font-size: 42px;
            }
        }
        .factorization__answer-input {
            width: 70px !important;
            height: 30px !important;
            font-size: 16px !important;
            @include media($xl) {
                width: 110px !important;
                height: 40px !important;
                font-size: 18px !important;
            }
            @include media($xxl) {
                width: 130px !important;
                height: 50px !important;
                font-size: 22px !important;
            }
        }
        .factorization__answer-footer {
            margin-top: 0;
            .cs-button {
                font-size: 13px;
                padding: 7px 15px;
                margin-left: 8px;
                @include media($xl) {
                    font-size: 14px;
                    margin-left: 12px;
                }
                @include media($xxl) {
                    font-size: 16px;
                    padding: 15px 50px;
                    margin-left: 15px;
                }
            }
        }
        .factorization__reaction-container {
            .factorization__reaction-image_multiplayer {
                margin-bottom: 10px;
                max-width: 45%;
                @include media($xl) {
                    max-width: 80%;
                }
            }
            .cs-button {
                padding: 10px 30px;
                font-size: 14px;
                @include media($xxl) {
                    padding: 15px 30px;
                    font-size: 18px;
                }
            }
        }
        .factorization__reaction {
            flex-grow: 0;
            margin-top: 1rem;
            @include media($xxl) {
                margin-top: 4rem;
            }
        }
        .factorization-help-text__end-multiplayer-game {
            margin-top: 20%;
        }
    }
</style>
